import React, { useState } from "react";
import { Container, Card, Button, Form } from "react-bootstrap";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import Header from './Header';
import Footer from './Footer';
import '../css/blog.css';

const JpegToPdfConverter = () => {
  const [images, setImages] = useState([]);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setImages(files.map((file) => URL.createObjectURL(file)));
  };

  const convertToPdf = async () => {
    const doc = new jsPDF();
    for (let i = 0; i < images.length; i++) {
      const img = new Image();
      img.src = images[i];
      await new Promise((resolve) => {
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          const imgData = canvas.toDataURL("image/jpeg");
          if (i > 0) doc.addPage();
          doc.addImage(imgData, "JPEG", 10, 10, 180, 160);
          resolve();
        };
      });
    }
    doc.save("converted.pdf");
  };

  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container className="d-flex justify-content-center align-items-center" style={{ marginTop: "5%", marginBottom: "10%" }}>
      <div className="shadow p-4 w-100 toolcontainer" >
        <h2 className="text-center mb-4">JPEG to PDF Converter | Fast, Free & High-Quality</h2>
        <p className="text-dark">
          Converting JPEG to PDF is quick, easy, and efficient with the right tool. Whether you need to merge multiple images into a single PDF or convert a single JPEG file, an online JPEG to PDF converter provides a seamless experience. This process is essential for sharing images in a more professional, compact, and printable format. With a fast, free, and high-quality conversion tool, you can ensure your images retain their clarity without watermarks or downloads. Simply upload your JPEG files, adjust settings if needed, and convert them into a polished PDF instantly. Try it today for hassle-free file management!
        </p>
        <Form.Group controlId="fileInput" className="mb-3">
          <Form.Control type="file" multiple accept="image/jpeg" onChange={handleFileChange} />
        </Form.Group>
        <div id="preview" className="p-3 text-center">
          {images.map((src, index) => (
            <img key={index} src={src} alt={`preview-${index}`} className="img-fluid m-2" style={{ maxWidth: "100px" }} />
          ))}
        </div>
        <Button onClick={convertToPdf} className="btn-primary mt-3">Convert to PDF</Button>
      </div>
    </Container>
    </div>
    <Footer />
    </>
  );
};

export default JpegToPdfConverter;
